import React from "react";
import { NavbarContainer } from "./NavbarStyles";
const Navbar = ({ children, displayEnvIndicator = false }) => {
    return React.createElement(NavbarContainer, { displayEnvIndicator: displayEnvIndicator }, children);
};
export default Navbar;
//# sourceMappingURL=Navbar.js.map